import angular from 'angular';
import { HomeServicesContentComponent } from './home-services-content.component';
import { MatchMediaModule } from '../../../common/directives/match-media';

export const HomeServicesContentModule = angular
  .module('app.steps.home-services.content', [MatchMediaModule.name])
  .component('updHomeServicesContent', HomeServicesContentComponent);
